import { render } from "./PageCryptoCurrency.vue?vue&type=template&id=0767bc3d&scoped=true"
import script from "./PageCryptoCurrency.vue?vue&type=script&lang=js"
export * from "./PageCryptoCurrency.vue?vue&type=script&lang=js"

import "./PageCryptoCurrency.vue?vue&type=style&index=0&id=0767bc3d&scoped=true&lang=css"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0767bc3d"]])

export default __exports__